"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOfficePlanningApiSchema = exports.officePlanningWorkScheduleItemSchema = void 0;
const zod_1 = require("zod");
const agenda_slot_1 = require("../agenda-slots/agenda-slot");
const api_1 = require("../global/api");
const event_schema_1 = require("../global/event.schema");
const paginate_list_api_response_schema_1 = require("../global/paginate-list-api-response.schema");
exports.officePlanningWorkScheduleItemSchema = zod_1.z.object({
    periodOfTheDay: zod_1.z.enum(event_schema_1.periodsOfTheDay),
    doctorAttendingInformation: zod_1.z.object({
        id: zod_1.z.string(),
        firstname: zod_1.z.string(),
        lastname: zod_1.z.string(),
        email: zod_1.z.string(),
    }),
    slotOpened: zod_1.z
        .object({
        id: zod_1.z.string(),
        type: agenda_slot_1.agendaSlotTypeSchema,
        retrocessionRate: zod_1.z.number(),
        withAssistant: zod_1.z.boolean(),
        openedAt: zod_1.z.coerce.date(),
    })
        .nullable()
        .default(null),
    slotBooked: zod_1.z
        .object({
        id: zod_1.z.string(),
        type: agenda_slot_1.agendaSlotTypeSchema,
        retrocessionRate: zod_1.z.number(),
        withAssistant: zod_1.z.boolean(),
        doctorSubstituteInformation: zod_1.z.object({
            id: zod_1.z.string(),
            firstname: zod_1.z.string(),
            lastname: zod_1.z.string(),
            email: zod_1.z.string(),
        }),
        bookedAt: zod_1.z.coerce.date(),
        reservationIndex: zod_1.z.number().nullable().default(null),
    })
        .nullable()
        .default(null),
});
const officePlanningItemApiSchema = zod_1.z.object({
    id: zod_1.z.string(),
    type: (0, api_1.apiEntityTypeSchema)('office-planning-days'),
    attributes: zod_1.z.object({
        date: zod_1.z.string(),
        dayOfWeek: zod_1.z.enum(event_schema_1.daysOfWeek),
        doctorsWorkSchedules: zod_1.z.array(exports.officePlanningWorkScheduleItemSchema),
    }),
});
exports.getOfficePlanningApiSchema = (0, paginate_list_api_response_schema_1.paginteListApiResponseSchema)(officePlanningItemApiSchema);
